/* White Noise The Label: approximate local price (Heidi, AI CTO, 16 Oct 2026, theme v23 preview).
   Tugba, 16 Oct: show an approximate price for visitors outside the UAE. The price and the checkout stay
   in AED; this only adds one quiet line under the product page's main price, for example
   "APPROX. GBP 380 · CHARGED IN AED". Nothing shows for the UAE, for an unknown country, or if no rate loads.
   Country: Shopify's own server-timing "country" entry on this page (no extra request); fallback /cdn-cgi/trace.
   Rates: the free daily AED feed on jsDelivr (already used by the site), kept in this browser for 12 hours.
   Test: add ?wn_fx_country=GB (or SA, US...) to a product page; it holds for this tab only. ?wn_fx_country=off clears it.
   Style: wn-golive.css section 12. Loaded from layout/theme.liquid on product pages only. */
(function () {
  'use strict';

  var BASE = 'AED';
  var FEEDS = [
    'https://cdn.jsdelivr.net/npm/@fawazahmed0/currency-api@latest/v1/currencies/aed.json'
  ];
  var CACHE_KEY = 'wn_fx_aed_v1';
  var CACHE_MS = 12 * 60 * 60 * 1000;
  var MAX_FEED_AGE_DAYS = 7;
  var TEST_KEY = 'wn_fx_country';

  /* Country to currency. Anything not listed shows USD. */
  var MAP = {
    SA: 'SAR', QA: 'QAR', KW: 'KWD', BH: 'BHD', OM: 'OMR',
    GB: 'GBP', US: 'USD', AU: 'AUD', CA: 'CAD', CH: 'CHF', IN: 'INR', JP: 'JPY', CN: 'CNY',
    KR: 'KRW', SG: 'SGD', HK: 'HKD', TR: 'TRY', NZ: 'NZD', SE: 'SEK', NO: 'NOK', DK: 'DKK',
    ZA: 'ZAR', EG: 'EGP', LB: 'USD'
  };
  /* The euro countries (euro area, with Bulgaria from 1 Jan 2026) and the small states that use the euro. */
  ['AT', 'BE', 'BG', 'HR', 'CY', 'EE', 'FI', 'FR', 'DE', 'GR', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PT',
    'SK', 'SI', 'ES', 'AD', 'MC', 'SM', 'VA', 'ME', 'XK'].forEach(function (c) { MAP[c] = 'EUR'; });

  function currencyFor(country) { return MAP[country] || 'USD'; }

  function wanted() {
    var list = ['usd'];
    Object.keys(MAP).forEach(function (k) {
      var c = MAP[k].toLowerCase();
      if (list.indexOf(c) < 0) list.push(c);
    });
    return list;
  }

  /* ---------- Country ---------- */
  function clean(code) {
    code = String(code || '').trim().toUpperCase();
    if (!/^[A-Z]{2}$/.test(code) || code === 'XX' || code === 'T1') return '';
    return code;
  }

  function testCountry() {
    var v = '';
    try { v = new URLSearchParams(location.search).get(TEST_KEY) || ''; } catch (e) {}
    try {
      if (v) {
        if (/^(off|clear|none)$/i.test(v)) { sessionStorage.removeItem(TEST_KEY); return ''; }
        v = clean(v);
        if (v) sessionStorage.setItem(TEST_KEY, v);
        return v;
      }
      return clean(sessionStorage.getItem(TEST_KEY));
    } catch (e) { return clean(v); }
  }

  function timingCountry() {
    try {
      var nav = performance.getEntriesByType('navigation')[0];
      var st = (nav && nav.serverTiming) || [];
      for (var i = 0; i < st.length; i++) {
        if (st[i].name === 'country') return clean(st[i].description);
      }
    } catch (e) {}
    return '';
  }

  /* "no-cache" asks the server whether its copy is newer, so a week-long browser copy of the feed is never reused. */
  function withTimeout(url, ms) {
    var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, ms) : null;
    var opts = { credentials: 'omit', cache: 'no-cache' };
    if (ctrl) opts.signal = ctrl.signal;
    return fetch(url, opts)
      .then(function (r) { if (timer) clearTimeout(timer); if (!r.ok) throw new Error(r.status); return r; },
            function (e) { if (timer) clearTimeout(timer); throw e; });
  }

  function traceCountry() {
    return withTimeout('/cdn-cgi/trace', 3000)
      .then(function (r) { return r.text(); })
      .then(function (t) { var m = /(?:^|\n)loc=([A-Za-z0-9]{2})/.exec(t); return m ? clean(m[1]) : ''; })
      .catch(function () { return ''; });
  }

  /* ---------- Rates ---------- */
  function readCache() {
    try {
      var c = JSON.parse(localStorage.getItem(CACHE_KEY) || 'null');
      if (c && c.r && typeof c.ts === 'number' && Date.now() - c.ts < CACHE_MS) return c;
    } catch (e) {}
    return null;
  }

  function writeCache(c) {
    try { localStorage.setItem(CACHE_KEY, JSON.stringify(c)); } catch (e) {}
  }

  function feedAgeOk(date) {
    var t = Date.parse(String(date || '') + 'T00:00:00Z');
    return isFinite(t) && (Date.now() - t) < MAX_FEED_AGE_DAYS * 86400000;
  }

  function fetchRates(i) {
    i = i || 0;
    if (i >= FEEDS.length) return Promise.resolve(null);
    return withTimeout(FEEDS[i], 5000)
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var all = d && d.aed;
        if (!all || !feedAgeOk(d.date)) throw new Error('feed');
        var r = {};
        wanted().forEach(function (c) { var v = Number(all[c]); if (isFinite(v) && v > 0) r[c] = v; });
        if (!r.usd) throw new Error('feed');
        var c = { ts: Date.now(), date: d.date, src: i, r: r };
        writeCache(c);
        return c;
      })
      .catch(function () { return fetchRates(i + 1); });
  }

  /* ---------- Price on the page ---------- */
  function parseMoney(t) {
    var s = String(t || '').replace(/[^\d.,]/g, '');
    if (!s) return NaN;
    var m = /^(.*?)[.,](\d{2})$/.exec(s);
    if (m) return parseFloat((m[1].replace(/[.,]/g, '') || '0') + '.' + m[2]);
    return parseFloat(s.replace(/[.,]/g, ''));
  }

  function ldPrice() {
    try {
      var nodes = document.querySelectorAll('script[type="application/ld+json"]');
      for (var i = 0; i < nodes.length; i++) {
        var txt = nodes[i].textContent || '';
        if (txt.indexOf('"offers"') < 0) continue;
        var d = JSON.parse(txt);
        var offers = d && d.offers;
        if (offers && !Array.isArray(offers)) offers = [offers];
        if (offers && offers[0] && String(offers[0].priceCurrency).toUpperCase() === BASE) return Number(offers[0].price);
      }
    } catch (e) {}
    return NaN;
  }

  function pagePrice(holder) {
    var price = holder.querySelector('.price');
    var el = null;
    if (price) {
      el = price.classList.contains('price--on-sale')
        ? price.querySelector('.price__sale .price-item--sale')
        : price.querySelector('.price__regular .price-item--regular');
      el = el || price.querySelector('.price-item--last') || price.querySelector('.price-item');
    }
    var txt = el ? el.textContent : '';
    if (txt && txt.toUpperCase().indexOf(BASE) < 0 && /[A-Z]{3}/.test(txt.toUpperCase())) return NaN;
    var v = parseMoney(txt);
    return isFinite(v) && v > 0 ? v : ldPrice();
  }

  /* ---------- The line ---------- */
  function fmt(v) {
    var n = v >= 1000 ? Math.round(v / 10) * 10 : Math.round(v);
    try { return new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(n); }
    catch (e) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  }

  /* The main product section only (both product templates call it "main"): never a quick-add or a card. */
  function holders() {
    return Array.prototype.slice.call(document.querySelectorAll('product-info .product__price-holder[id^="price-"][id$="__main"]'));
  }

  /* Placed after the price's own installment block, so the phone order in wn-golive.css section 3 still holds. */
  function anchorFor(holder) {
    var next = holder.nextElementSibling;
    if (next && next.tagName === 'DIV' && next.querySelector('form.installment, form[id^="product-form-installment"]')) return next;
    return holder;
  }

  function lineFor(holder, create) {
    var id = 'wn-fx-' + holder.id;
    var line = document.getElementById(id);
    if (!line && create) {
      line = document.createElement('p');
      line.id = id;
      line.className = 'wn-fx-line is-pending';
      line.setAttribute('aria-hidden', 'true');
      line.textContent = ' ';
      var a = anchorFor(holder);
      a.parentNode.insertBefore(line, a.nextSibling);
    }
    return line;
  }

  function removeAll() {
    holders().forEach(function (h) { var l = lineFor(h, false); if (l) l.parentNode.removeChild(l); });
  }

  var state = { country: '', ccy: '', rates: null };

  function render() {
    holders().forEach(function (holder) {
      if (!state.rates) { lineFor(holder, true); return; } /* still loading: the space is held, nothing printed */
      var rate = state.rates.r[state.ccy.toLowerCase()];
      var aed = pagePrice(holder);
      var amount = (rate && isFinite(aed) && aed > 0) ? fmt(aed * rate) : '0';
      if (amount === '0') {
        var old = lineFor(holder, false);
        if (old) old.parentNode.removeChild(old);
        return;
      }
      var text = 'APPROX. ' + state.ccy + ' ' + amount + ' · CHARGED IN ' + BASE;
      var line = lineFor(holder, true);
      if (line.textContent !== text) line.textContent = text;
      if (line.classList.contains('is-pending')) { line.classList.remove('is-pending'); line.removeAttribute('aria-hidden'); }
      var meta = state.country + ' ' + state.ccy + ' ' + rate + ' ' + state.rates.date + ' feed' + (state.rates.src + 1);
      if (line.getAttribute('data-fx') !== meta) line.setAttribute('data-fx', meta);
    });
  }

  function watch() {
    var root = document.getElementById('MainContent') || document.body;
    var queued = false;
    var obs = new MutationObserver(function () {
      if (queued) return;
      queued = true;
      setTimeout(function () { queued = false; try { render(); } catch (e) {} }, 60);
    });
    obs.observe(root, { childList: true, subtree: true, characterData: true });
  }

  function start(country) {
    if (!country || country === 'AE') return;
    try { if (window.Shopify && Shopify.currency && Shopify.currency.active && Shopify.currency.active !== BASE) return; } catch (e) {}
    state.country = country;
    state.ccy = currencyFor(country);
    if (state.ccy === BASE) return;
    if (!holders().length) return;
    state.rates = readCache();
    render();
    if (state.rates) { watch(); return; }
    fetchRates(0).then(function (c) {
      if (!c) { removeAll(); return; }
      state.rates = c;
      render();
      watch();
    });
  }

  function init() {
    try {
      var c = testCountry() || timingCountry();
      if (c) { start(c); return; }
      traceCountry().then(function (t) { try { start(t); } catch (e) {} });
    } catch (e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
